import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "quantity-selector" }
const _hoisted_2 = { class: "quantity-selector__summary" }
const _hoisted_3 = { class: "quantity-selector__title" }
const _hoisted_4 = { class: "quantity-selector__content" }
const _hoisted_5 = {
  key: 0,
  class: "quantity-selector__content-title"
}

import { ref, computed, onMounted, inject } from 'vue';

import { configuratorStateKey } from '../ProductConfiguratorKeys';
import { inputFocusKey } from '../ProductConfiguratorKeys';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import QuantitySelectorRow from './QuantitySelectorRow.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfiguratorQuantitySelector',
  props: {
  variants: {
    type: Array,
    required: true
  },
  hasDecoration: {
    type: Boolean,
    default: false
  },
  supportedVariants: {
    type: Array,
    required: true
  },
  selectedDecorationName: {
    type: String,
    default: ''
  },
  isGiftCard: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const { configuratorState, updateQuantity } = inject(configuratorStateKey);
const { websiteText } = useWebsiteTexts();
const { inputFocus } = inject(inputFocusKey);

const props = __props;

const currentQuantity = computed(
  () => configuratorState.value.quantities || {}
);
const currentQuantityText = computed(() => {
  return `${configuratorState.value.sumQuantity} ${
    websiteText('productdetailspage_printpieceabbreviated').value
  }`;
});

const packageInfoText = computed(() => {
  const firstVariant = props.variants?.[0];
  if (!firstVariant?.packaging?.caption) return '';

  return websiteText('configurator__quantity_info', {
    package: firstVariant.packaging.caption.toLowerCase()
  }).value;
});

function changeQuantity(variantQuantity) {
  updateQuantity(variantQuantity.id, variantQuantity.quantity);
}

function isVariantSupported(variantSystemId) {
  return (
    !props.hasDecoration ||
    props.supportedVariants.indexOf(variantSystemId) !== -1
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(websiteText)('configurator__choose_quantity').value), 1),
      _createElementVNode("p", {
        class: _normalizeClass([
          'quantity-selector__quantity',
          { 'quantity-selector__quantity--highlighted': _unref(inputFocus) }
        ])
      }, _toDisplayString(currentQuantityText.value), 3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (packageInfoText.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(packageInfoText.value), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.variants, (variant) => {
        return (_openBlock(), _createBlock(QuantitySelectorRow, {
          key: variant.systemId,
          variant: variant,
          "has-decoration": __props.hasDecoration,
          quantity: currentQuantity.value[variant.systemId],
          variantSupported: isVariantSupported(variant.systemId),
          selectedDecorationName: props.selectedDecorationName,
          isGiftCard: __props.isGiftCard,
          onUpdateQuantity: changeQuantity
        }, null, 8, ["variant", "has-decoration", "quantity", "variantSupported", "selectedDecorationName", "isGiftCard"]))
      }), 128))
    ])
  ]))
}
}

})